'use strict';



module.exports = /*@ngInject*/ ["$stateParams", "EventResource", "$filter", "NgTableParams",  function SimMonitoringPageController($stateParams,EventResource, $filter, NgTableParams) {
    var vm = this;

    vm.trainId = $stateParams.trainId;
   vm.projectId = $stateParams.projectId;

    /*
     FUNCTIONS
     */

     function getTrainEvents(trainId, projectId) {
         EventResource.getTrainEvents().query({
             'projectId': projectId,
             'trainId': trainId
         }).$promise.then(function (data) {
             vm.events = data && data.map(function (event) {
                var message = event.message.replace(/_/g, " ")
                 event.message = message.replace('mar3_', '')
                 return event;
             })
             vm && vm.tableParamsEvents && vm.tableParamsEvents.reload();
         });

     }
     getTrainEvents(vm.trainId, vm.projectId)


    vm.$onInit = function () {

        vm.tableParamsEvents = new NgTableParams({
            page: 1,            // show first page
            count: 500,          // count per page
            filter: {},

            sorting: { timestamp: 'desc' }

        }, {
            counts: vm.events && vm.events.length <= 10 ? [] : [10, 25, 50, 100, 500],
            total: (vm.events ? vm.events.length : 0), // length of data
            getData: function (params) {

                if (vm.events && vm.events.length > 0) {
                    var sortedData = params.sorting() ? $filter('orderBy')(vm.events, params.orderBy()) : vm.events;

                    params.total(sortedData.length);
                    return sortedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
                } else {

                    params.total(0);
                    return [];
                }

            }.bind(vm)
        });
    };

    vm.$onChanges = function () {

        vm && vm.tableParamsEvents && vm.tableParamsEvents.reload();
    };

    vm.sortData = function (field, event) {

        var sortingValObj = (event.shiftKey ? vm.tableParamsEvents.sorting() : {});

        if (sortingValObj.hasOwnProperty(field)) {
            sortingValObj[field] = ((sortingValObj[field] === 'asc') ? 'desc' : 'asc');
        } else {
            sortingValObj[field] = (vm.tableParamsEvents.isSortBy(field, 'asc') ? 'desc' : 'asc');
        }

        vm.tableParamsEvents.sorting(sortingValObj);
        vm.tableParamsEvents.reload();
    };
}];